// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__1WZn6","Label":"Input_Label__In9_C"};